import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class SearchService {
  searching = new BehaviorSubject(false);
}
